<template>
  <div class="w-100">
    <div class="mb-2">
      <table class="table table-borderless table-middle table-sm w-100 custom-th my-0 mx-auto"
        style="max-width:991px">
        <tbody align="left">
          <tr>
            <td scope="row" class="p-0 m-0 position-relative pro-img" rowspan="5"
              style="vertical-align:top">
              <div class="p-1 border">
                <div class="border border-dark mt-1 bg-secondary d-flex mx-auto position-relative"
                  style="z-index:1;height:100px;width:100px">
                  <span class="text-white align-self-center mx-auto">160 x 160</span>
                  <div class="w-100 py-1 text-center position-absolute text-white-50"
                    style="top:0;left:10px;z-index:2;font-size:12px">
                    <img src alt="商品縮圖" style="min-width:100px" />
                  </div>
                </div>
                <div class="text-center my-1" style="z-index:3;">
                  <button type="button" class="btn btn-sm btn-primary mr-1">上傳</button>
                  <button type="button" class="btn btn-sm btn-primary ml-1">相簿</button>
                </div>
              </div>
            </td>
            <th>上架分類</th>
            <td>
              <div class="d-flex align-items-center">
                <b-form-select size :value='thdata.Class1' @input="changeinput('Class1', $event)"
                  :options="options"></b-form-select>
                <b-form-select size :value='thdata.Class2' @input="changeinput('Class2', $event)"
                  :options="options"></b-form-select>
              </div>
            </td>
            <th>內部分類</th>
            <td>
              <b-form-select size :value='thdata.inClass' @input="changeinput('inClass', $event)"
                :options=" options"></b-form-select>
            </td>
          </tr>
          <tr>
            <th>商品代號</th>
            <td>
              <b-form-input size :value='thdata.code' @input="changeinput('code', $event)">
              </b-form-input>
            </td>
            <th>版次</th>
            <td>
              <b-form-input size :value='thdata.version' @input="changeinput('version', $event)">
              </b-form-input>
            </td>
          </tr>
          <tr>
            <th>商品名稱</th>
            <td colspan="3">
              <b-form-input size :value='thdata.name' @input="changeinput('name', $event)">
              </b-form-input>
            </td>
          </tr>
          <tr>
            <th>
              基本價格
              <small class="d-inline-block d-md-block pl-2 pl-md-0">
                <a href="#">設定會員價</a>
              </small>
            </th>
            <td colspan="3" valign="middle">
              <div class="d-flex flex-fill justify-content-around">
                <div class="d-flex flex-md-row flex-column w-100 align-items-center">
                  <b-input-group size class="flex-fill mb-0" :class="{'pr-md-1':((key+1) < 3)}"
                    v-for="(i,key) in priceKid" :key='"PriceKid__"+i.field'>
                    <template v-slot:prepend>
                      <b-input-group-text>{{i.name}}$</b-input-group-text>
                    </template>
                    <b-form-input type="number" class="text-right" :value='thdata.price[i.field]'
                      @input="changeinput(i.field, $event,'price')"></b-form-input>
                  </b-input-group>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>銷售狀態</th>
            <td colspan="3">
              <div class='d-flex'>
                <!-- <b-form-group class="m-0"> -->
                <!-- <b-form-checkbox-group name="sellstatus"> -->
                <b-form-checkbox class="mr-5" :checked="thdata.sela" value='1'
                  @input="changeinput('sela', $event)">銷售鈕開啟</b-form-checkbox>
                <b-form-checkbox class="mr-5" :checked="thdata.hit" value='1'
                  @input="changeinput('hit', $event)">熱門商品</b-form-checkbox>
                <b-form-checkbox :checked="thdata.online" value='1'
                  @input="changeinput('online', $event)">下架</b-form-checkbox>
                <!-- </b-form-checkbox-group> -->
                <!-- </b-form-group> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class>
      <hr />
    </div>
    <div class="mb-2">
      <table class="table table-borderless table-middle table-sm w-100 custom-th my-0 mx-auto"
        style="max-width:991px">
        <tbody align="left">
          <tr>
            <th style="vertical-align:top">簡介 {{thdata.context}}</th>
            <td>
             
              <b-form-textarea size :rows='5' :value='thdata.context'
                @input="changeinput('context', $event)"></b-form-textarea>
            </td>
          </tr>
          <tr>
            <th>前台順序</th>
            <td>
              <b-form-group line class="m-0">
                <b-form-radio-group :checked="thdata.order.method"
                  @input="changeinput('method', $event,'order')">
                  <b-form-radio class="mr-5" value="first">放第1筆</b-form-radio>
                  <b-form-radio class="mr-5" value="last">放最後</b-form-radio>
                  <b-form-radio value="custom" class="align-items-center">
                    <div class="d-flex flex-fill align-items-center">
                      自訂：
                      <div>第</div>
                      <div class="col-4">
                        <b-form-input type="number" class="py-0 pr-0 text-center"
                          style="height:100%" size :disabled="!(thdata.order.method=='custom')"
                          :value="thdata.order.order"
                          @input="changeinput('order', $event,'order')">
                        </b-form-input>
                      </div>
                      <div>筆</div>
                    </div>
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import ctrl from './insBaseField.js';
  export default ctrl;

</script>

<style lang="scss">
  .ck-editor__editable {
    //min-height: 500px !important;
  }

  .labelBase {
    min-width: 100px;
  }

  .custom-lable {
    max-width: 5.5em;
  }

</style>
